import React from 'react';
import {useTranslation} from 'react-i18next';

import {useAuthStore} from '@/entities/session/auth-store';
import {AttendanceMonth} from '@/features/view-my-attendance/ui/AttendanceMonth';
import {Page} from '@/shared/ui/page';
import {ContextPlaceholder} from '@/widgets/context-placeholder/ContextPlaceholder';

/**
 * «Я — сотрудник» → Посещаемость. Отчёт сам ограничен собой на сервере (личность
 * берётся из JWT); компания нужна только для заголовка запроса.
 */
export function MyAttendanceScreen() {
  const {t} = useTranslation();
  const companyId = useAuthStore(s => s.activeContext?.companyId);

  if (!companyId) {
    return <ContextPlaceholder titleKey="nav.myAttendance" />;
  }

  return (
    <Page width="form" title={t('nav.myAttendance')} testID="my-attendance-screen">
      <AttendanceMonth companyId={companyId} />
    </Page>
  );
}
